import { css } from 'styled-components';
import { pickColor } from 'themes/helpers/pickColor';

const motives = {
  default: css`
    flex-direction: column;

    font-size: 1.2rem;

    label {
      height: 1.9rem;
      padding: 0;

      text-transform: uppercase;
      font-family: 'LFT Zeno Condensed', sans-serif;
      font-size: 1.1rem;
      font-weight: 600;
      letter-spacing: 0.1rem;

      color: ${pickColor('black')};
    }
  `,
  user: css`
    align-items: center;

    font-size: 1.2rem;

    label {
      padding: 1rem 2rem 1rem 0;
      width: 14rem;

      font-weight: 600;
      font-family: 'LFT Zeno Condensed', sans-serif;
      font-size: 1.6rem;

      letter-spacing: 0.1rem;
      text-transform: uppercase;

      color: ${pickColor('black')};
    }

    > div:nth-child(2) {
      width: auto;
      flex-grow: 1;
    }
  `,
  filter: css`
    flex-direction: column;

    label {
      height: 1.9rem;
      padding: 0;

      font-family: 'LFT Zeno', sans-serif;
      font-size: 1.1rem;
      font-weight: 600;
      letter-spacing: 0.1rem;

      color: ${pickColor('black')};
    }
  `,
  disabled: css`
    flex-direction: column;

    label {
      height: 1.9rem;
      padding: 0;

      text-transform: uppercase;
      font-family: 'LFT Zeno Condensed', sans-serif;
      font-size: 1.1rem;
      font-weight: 600;
      letter-spacing: 0.1rem;

      color: ${pickColor('black')};
    }
  `,
};

export type SelectMotives = keyof typeof motives;

const pickMotive = (motive: SelectMotives) => motives[motive];

export { pickMotive };
